var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', true);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            /*$('.home .carousel').on('slide.bs.carousel', (event: any) => {
              this.updateBackgroundLuminance(event.relatedTarget);
            });
        
            this.updateBackgroundLuminance('.home .carousel-item.active');
        
            $(window).on('scroll', () => {
              const windowHeight = $(window).height();
        
              $('.highlight .arrow-right').each((arrowRight: Collection, index: number) => {
                const parent = arrowRight.parent();
                const reference = parent.hasClass('highlight-image') ? parent.find('.images') : parent;
        
                let bottom = 15;
                let parentBottom = parent.viewportPosition().y + parent.height();
                if (parentBottom > windowHeight) {
                  bottom = parentBottom - windowHeight + 15;
                }
              
                if (index == 0) console.log(bottom + arrowRight.height(), reference.height())
                if (bottom + arrowRight.height() > reference.height() - 15) bottom = reference.height() - 15 - arrowRight.height();
        
                //console.log(bottom)
                arrowRight.css({
                  'bottom': bottom
                });
              });
            });*/
            this.success();
        });
    }
    updateBackgroundLuminance(target) {
        $('.home .carousel').css('--background-luminance', $(target).css('--background-luminance'));
    }
}
